import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Action from "../../_redux/applicantActions";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import { TextArea } from "../../../../../_metronic/_partials/controls/forms/TextArea";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import { Radio } from "antd";

const _init = {
  is_relative_working: true,
  name: "",
  phone: "",
  relation: "",
};

const RelativeInBracInformation = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(_init);

  // Validation schema
  const validationSchema = Yup.object().shape({
    is_relative_working: Yup.bool().required("Is Relative Working is required"),
    name: Yup.string().when("is_relative_working", {
      is: true,
      then: Yup.string().required("Relative Name is required"),
    }),
    phone: Yup.string().when("is_relative_working", {
      is: true,
      then: Yup.string()
        .required("Relative Phone is required")
        .matches(
          /^\d{1,11}$/,
          "Phone number must be at most 11 digits and contain only numbers"
        ),
    }),
    relation: Yup.string().when("is_relative_working", {
      is: true,
      then: Yup.string().required("Relation with relative is required"),
    }),
    // name: Yup.string().required("Relative Name is required"),
    // phone: Yup.string().required("Relative Phone is required"),
    // relation: Yup.string().required("Extracurricular Activities is required"),
  });

  const handleSaveProfile = async (values) => {
    const response = await API.post(
      "hrms_applicant/save-relative-info/" + id,
      values
    );
    if (response.data.success) {
      swalSuccess(response.data.message);
      if (values.length) {
        dispatch(
          Action.createProfileScore(
            {
              name: ["Relatives"],
              applicant_id: id,
            },
            () => {
              dispatch(Action.getApplicantPersonalInfo(id));
              fetchData();
            }
          )
        );
      } else {
        dispatch(
          Action.createProfileScore(
            {
              name: ["Relatives"],
              applicant_id: id,
            },
            () => {
              dispatch(Action.getApplicantPersonalInfo(id));
              fetchData();
            }
          )
        );
      }
      // fetchData();
    } else {
      swalError(response.data.message);
    }
  };

  const fetchData = async () => {
    const response = await API.get("hrms_applicant/get-relative-info/" + id);
    if (response.data.success) {
      if (Object.keys(response.data.data).length) {
        setProfile({
          is_relative_working: response.data.data.is_relative_working
            ? true
            : false,
          name: response.data.data?.name ?? "",
          phone: response.data.data?.phone ?? "",
          relation: response.data.data?.relation ?? "",
        });
      }
    } else {
      swalError(response.data.message);
    }
  };
  useEffect(() => {
    if (id) {
      // get-objective
      fetchData();
    }
  }, [id]);
  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={profile}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Acquaintance Working in BRACU</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 mb-5">
                        <p className="m-0 p-0">
                          Are you acquainted with anyone currently employed at
                          BRAC University?
                        </p>
                        <br />
                        <Radio.Group
                          onChange={(e) => {
                            setFieldValue(
                              "is_relative_working",
                              e.target.value
                            );
                          }}
                          value={values.is_relative_working}
                          options={[
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                          ]}
                        />
                        {errors.is_relative_working &&
                          touched.is_relative_working && (
                            <div className="text-danger">
                              {errors.is_relative_working}
                            </div>
                          )}
                      </div>
                      {values.is_relative_working && (
                        <>
                          <div className="col-md-4">
                            <Input
                              label={"Acquaintance Name"}
                              isRequired
                              value={values.name}
                              onChange={(e) => {
                                setFieldValue("name", e.target.value);
                              }}
                            />
                            {errors.name && touched.name && (
                              <div className="text-danger">{errors.name}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <Input
                              label={"Phone Number"}
                              isRequired
                              value={values.phone}
                              onChange={(e) => {
                                setFieldValue("phone", e.target.value);
                              }}
                            />
                            {errors.phone && touched.phone && (
                              <div className="text-danger">{errors.phone}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <Input
                              label={"Relation"}
                              isRequired
                              value={values.relation}
                              onChange={(e) => {
                                setFieldValue("relation", e.target.value);
                              }}
                            />
                            {errors.relation && touched.relation && (
                              <div className="text-danger">
                                {errors.relation}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default RelativeInBracInformation;
